import { useVersionData } from 'utils/hooks/useVersionData';
import {
    Footer as FlowbiteFooter,
    FooterCopyright as FlowbiteFooterCopyright,
} from 'flowbite-react';
import { setAppVersionForZendesk } from 'utils/hooks/useZendeskWidget';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { versionInfo } = useVersionData();

    setAppVersionForZendesk(versionInfo);

    return (
        <FlowbiteFooter className="text-xs p-4">
            <FlowbiteFooterCopyright
                by="Bigleaf Networks, Inc"
                year={currentYear}
            />
            {versionInfo}
        </FlowbiteFooter>
    );
};

export default Footer;
